// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Card, Typography } from '../../lib/base';
import { CenteredView } from '../../lib/layout';
import { Time } from '../common/time';

const RetryArea = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}));

const Headline = styled(Typography)(({ theme }) => ({
  paddingBottom: theme.spacing(1),
  paddingTop: theme.spacing(1),
}));

const Root = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2),
  },
}));

interface Props {
  readonly maintenanceStartTime?: number;
  readonly maintenanceDurationMinutes?: number;
}

export default function Maintenance({ maintenanceStartTime, maintenanceDurationMinutes }: Props) {
  return (
    <div>
      <Helmet>
        <title>{'Maintenance'}</title>
      </Helmet>
      <CenteredView>
        <Card>
          <Root>
            {/* <Logo width={48} height={56} /> */}
            <Headline variant="h4">Down for Maintenance</Headline>
            <RetryArea>
              <Typography sx={{ textAlign: 'center' }} variant="subtitle1">
                Microgreen Manager is currently down for maintenance. Please go to one of our social media accounts
                linked in the footer to find out more. Refresh the page in a few minutes or try again later.
              </Typography>
              {maintenanceStartTime && (
                <Box sx={{ pt: 1 }} display="flex" flexDirection="column" alignItems="center">
                  <Typography variant="subtitle1">Maintenance started around</Typography>
                  <Time time={maintenanceStartTime} options={{ time: true }} />
                </Box>
              )}
              {maintenanceDurationMinutes && (
                <Typography sx={{ pt: 2, textAlign: 'center' }} variant="subtitle1">
                  And is expected to last for approximately {maintenanceDurationMinutes} minutes.
                </Typography>
              )}
            </RetryArea>
          </Root>
        </Card>
      </CenteredView>
    </div>
  );
}
